<script lang="ts">
  import { Wrapper } from 'customer-components/lib/components';
  import type { UseFormattedProps } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
</script>

<Wrapper
  background={'var(--vlt-lp-background)'}
  style={'padding-top: 0px;margin-top:0;'}
>
  <div class="formatted-text-wrapper">
    {@html properties.html}
  </div>
</Wrapper>

<style lang="scss">
  .formatted-text-wrapper {
    max-width: 1136px;
    margin: 0 auto;
    padding: 0 15px;
    background: var(--vlt-lp-background, #ffffff);

    :global(*) {
      color: var(--vlt-lp-background-text, #0e0f11);
      font-family: var(--vlt-lp-paragraph-font, 'DM Sans');
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      max-width: 100%;
      word-break: break-word;
    }
    :global(p) {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      letter-spacing: 0.16px;
    }
    :global(h1),
    :global(h2),
    :global(h3),
    :global(h4),
    :global(h5),
    :global(h6) {
      color: var(--vlt-lp-background-text, #0e0f11);
      font-family: var(--vlt-lp-heading-font, 'DM Sans');
      padding: 1em 0;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      max-width: 100%;
      word-break: break-word;
    }
  }
</style>
